
import { Button, Grid, TextField, Box } from '@mui/material';
import OrderCard from './OrderCard';

import React, { useEffect, useSyncExternalStore } from "react";
import { getOrderHistory } from '../../../State/Order/Action';
import { useDispatch, useSelector } from "react-redux";

const orderStatus = [

    { lable: "On The Way", value: "on_the_way" },
    { lable: "Delivered", value: "delevered" },
    { lable: "Cancelled", value: "cancelled" },
    { lable: "Returned", value: "returned" },
]

const Order = () => {
    const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const {order}=useSelector(store=>store);

  useEffect(() => {
    dispatch(getOrderHistory({ jwt }));
  }, [jwt]);
    return (
        <Box className="px-10">
          <Grid container spacing={0} sx={{ justifyContent: "space-between" }}>
            <Grid item xs={2.5} className="">
              <div className="h-auto shadow-lg bg-white border p-5 sticky top-5">
                <h1 className="font-bold text-lg">Filters</h1>
                <div className="space-y-4 mt-10">
                  <h1 className="font-semibold">ORDER STATUS</h1>
                  {orderStatus.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center">
                      <input
                        //   id={`filter-${section.id}-${optionIdx}`}
                        //   name={`${section.id}[]`}
                        defaultValue={option.value}
                        type="checkbox"
                        defaultChecked={option.checked}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      />
                      <label
                        //   htmlFor={`filter-${section.id}-${optionIdx}`}
                        className="ml-3 text-sm text-gray-600"
                      >
                        {option.lable}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
            <Grid item xs={9}>
              <Box className="space-y-5 ">
                {order.orders?.length>0 && order.orders?.map((order )=> {
                  return order?.orderItems?.map((item,index)=> <OrderCard item={item} order={order} />)
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
}
export default Order
